const state = () => ({})

const getters = {}

const actions = {
    init(vuex, {logicFilter, display, useCategoryFilter}) {
        core.setPage(display);
        core.useCategoryFilter(useCategoryFilter);

        const flFilter = [...logicFilter.main, ...logicFilter.other]

        flFilter.map(
            (spec) => {
                if (spec.type !== 'range-slider') {
                    core.initFilter(spec);
                } else {
                    core.initRange(spec);
                }
            }
        )
    },

    by({commit, rootGetters}, payload) {
        const spec = rootGetters['logicFilters/specification'](payload.id),
            isSelected = core.setFilter({spec, filter: payload.filter})
        commit('logicFilters/selectValue', {spec, filter: payload.filter, isSelected}, { root: true })
        core.openPage()
    },

    reset({commit, rootGetters}, payload) {
        const spec = rootGetters['logicFilters/specification'](payload.id),
            isSelected = core.removeFilter({spec, filter: payload.filter})
        commit('logicFilters/selectValue', {spec, filter: payload.filter, isSelected}, { root: true })
        core.openPage()
    },

    resetAll() {
        flAttributes = {}
        core.openPage()
    }
}

const mutations = {}

const flPage = {}

let flAttributes = {}

const core = {
    initFilter(spec) {
        spec.values.map((filter) => {
                if (filter.selected) {
                    core.setFilter({spec, filter})
                }
            }
        )
    },

    setFilter({spec, filter}) {
        if (utils.isFilterExists(spec)) {
            return core.addFilterOrRemove({spec, filter})
        }

        return core.addFilter({spec, filter})
    },

    addFilterOrRemove({spec, filter}) {
        if (utils.itMustStillBeRemoved({spec, filter})) {
            return core.removeFilter({spec, filter})
        }

        return core.addFilter({spec, filter})
    },

    addFilter({spec, filter}) {
        if (utils.skipFilter(spec)) {
            return true
        }

        if (utils.isOrFilter(spec) && utils.isFilterExists(spec)) {
            flAttributes[spec.name].push(filter.value)
        } else {
            flAttributes[spec.name] = [filter.value]
        }

        return true
    },

    removeFilter({spec, filter}) {
        if (utils.isOrFilter(spec) && flAttributes[spec.name].length > 1) {
            utils.deleteFilterValue(spec.name, filter.value);
            return false
        }
        utils.deleteFilter(spec.name);
        return false
    },

    initRange(spec) {
        let selected = Object.entries(spec.selectedRange).toString()
        let range = Object.entries(spec.totalRange).toString()

        if (selected !== range) {
            core.setRange(spec)
        }
    },

    setRange(spec) {
        if (utils.isFilterExists(spec) && utils.itMustStillBeRemoved(spec)) {
            return core.removeRange(spec)
        }

        return core.addRange(spec)
    },

    addRange(spec) {
        if (utils.skipFilter(spec)) {
            return true
        }

        flAttributes[spec.name] = [spec.selectedRange]

        return true
    },

    removeRange(spec) {
        utils.deleteFilter(spec.name);
        return false
    },

    setPage(display) {
        flPage.pageType = display;
    },

    useCategoryFilter(filter) {
        flPage.useCategoryFilter = filter;
    },

    openPage() {
        let url = new URL(window.location.href),
            param = url.searchParams,
            query = {};

        if (utils.isSearchPage() && param.get('searchparam')) {
            query.searchparam = param.get('searchparam')
        }

        query.attrib = flAttributes;

        if (param.get('sortorder')) {
            query.sortorder = param.get('sortorder')
        }

        query = window.jQuery.param(query);
        query = query.replace(/%5B/g, '[').replace(/%5D/g, ']');

        if (query) {
            query = '?' + query
        }

        window.open(url.pathname + query, '_self')
    },
}

const utils = {
    isFilterExists(spec) {
        return flAttributes[spec.name] !== undefined;
    },

    skipFilter(spec) {
        return (utils.useCategoryFilter() && utils.isCategory(spec));
    },

    isSearchPage() {
        return flPage.pageType === 'search';
    },

    useCategoryFilter() {
        return flPage.useCategoryFilter;
    },

    isCategory(spec) {
        return spec.name === 'Kategorie' || spec.name === 'Catégorie';
    },

    isOrFilter(spec) {
        return spec.combinationOperation === 'or'
    },

    itMustStillBeRemoved({spec, filter}) {
        return utils.exitsFilterValue({spec, filter});
    },

    exitsFilterValue({spec, filter}) {
        if (spec.type === 'range-slider') {
            return Object.entries(spec.selectedRange).toString() === Object.entries(spec.totalRange).toString()
        } else {
            return flAttributes[spec.name].find(element => element === filter.value) !== undefined
        }
    },

    deleteFilter(filterName) {
        delete flAttributes[filterName]
    },

    deleteFilterValue(filterName, filterValue) {
        flAttributes[filterName] = flAttributes[filterName].filter(value => value !== filterValue)
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
